import { Container, Filter, Sprite, Text, TextStyle, Texture } from "pixi.js";

export abstract class Sector extends Container {
    private sectorFrame: Sprite;
    private sectorText: Text;
    private textFilter: Filter;
    private frameFilter: Filter;

    public constructor(sectorFrameTexture: Texture, sectorText: string, sectorTextStyle:TextStyle) {
        super();
        this.sectorFrame = new Sprite(sectorFrameTexture);
        this.addChild(this.sectorFrame);
        this.sectorText = new Text(sectorText, sectorTextStyle);
        this.addChild(this.sectorText);
    }

    public setSectorTextPosition(x: number, y: number): void {
        this.sectorText.position.set(x, y);
    }

    public setFilters(textFilter: Filter, frameFilter: Filter): void {
        this.textFilter = textFilter;
        this.frameFilter = frameFilter;
        this.sectorFrame.filters = [this.frameFilter];
        this.sectorText.filters = [this.textFilter];
        this.textFilter.enabled = false;
        this.frameFilter.enabled = false;
    }

    public showFilters(): void {
        this.textFilter.enabled = true;
        this.frameFilter.enabled = true;
    }

    public hideFilters(): void {
        this.textFilter.enabled = false;
        this.frameFilter.enabled = false;
    }
}